var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shipment-Details",
    transform: "translate(-501.000000, -523.000000)",
    fill: "#29D454",
    stroke: "#009600",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(120.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 387,
    cy: 302,
    r: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDots);
export default __webpack_public_path__ + "static/media/icon-dots.ce02a58fc5164fcdc6aac50d06f9f62e.svg";
export { ForwardRef as ReactComponent };